import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ICON_LIBRARY } from '@core/constants';

@Component({
    selector: 'app-toolbar-button',
    templateUrl: './toolbar-button.component.html',
    styleUrls: ['./toolbar-button.component.scss'],
    standalone: false
})
export class ToolbarButtonComponent {
    @Input() color: 'danger' | 'primary' = 'primary';
    @Input() disabled: boolean;
    @Input() icon: string;
    @Input() text: string;
    @Input() library: string = ICON_LIBRARY.IONIC;

    @Output() click = new EventEmitter<MouseEvent>();

    iconLibrary = ICON_LIBRARY;

    isActive = false;

    handleClick(event: MouseEvent): void {
        event.preventDefault();
        event.cancelBubble = true;

        if (!this.disabled) {
            this.click.emit(event);
        }
    }

    handleMouseDown(): void {
        this.isActive = true;
    }

    handleMouseUp(): void {
        this.isActive = false;
    }
}
